import { StsPasswordModeData } from './sts-password-mode';
import { StsSecurityQuestionModeData } from './sts-security-question-mode';
import { StsDisclaimer } from './sts-disclaimer';
import { StsCaptchaType } from './sts-captcha-type.model';

export class StsTenant {
  id: string;
  name: string;
  code: string;
  clientCode: string;
  cmCode: string;
  isEmailRequired: boolean;
  allowUsername: boolean;
  allowUsernameAsUniqueId: boolean;
  isDisclaimerRequired: boolean;
  isEmailReadOnly: boolean;
  isLockedInThankYou: boolean;
  isDisabled: boolean;
  passwordMode: StsPasswordModeData;
  permittedBlacklistKeys: string;
  securityQuestionMode: StsSecurityQuestionModeData;
  sendPasswordChangeNotificationEmail: boolean;
  passwordRecoveryChoices: string[];
  isUserNameRecoverySupported = false;
  isSelfRegSupported = false;
  disclaimer: StsDisclaimer;
  defaultSecurityPolicy: any;
  rotateSecurityQuestions: boolean;
  sessionTimeout: number;
  currentLocale = 'en-CA';
  captchaType = StsCaptchaType.text;
  usefulPatterns: {[key: string]: string} = {};

  showHeaderNormal: boolean;
  showHeaderBanner: boolean;

  isTfaEnabled: boolean;
  isTfaTrustedDevicesEnabled: boolean;
  tfaDeliveryChannels: string;
  tfaPreferredMode: string;
  clientSpecific: string;

  isEmailCollectionEnabled: boolean;
  isUseEmailOnFileForRegistrationEnabled: boolean;

  constructor() {
  }

}
